
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inscription/domiciliation",
      function () {
        return require("private-next-pages/inscription/domiciliation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inscription/domiciliation"])
      });
    }
  